import { createTheme } from "@mui/material/styles";
import { dark, light } from "@mui/material/styles/createPalette";
import { frFR } from "@mui/material/locale"; // Import French locale

// Define the light theme
export const lightTheme = createTheme(
  {
    components: {
      // Name of the component
      MuiMenu: {
        // Here we target the MuiMenu component
        styleOverrides: {
          // We use styleOverrides to target the root of the component
          paper: {
            backgroundColor: "rgba(255,255,255)", // Change the background color
            color: "rgba(0,0,0)", // Change the text color
          },
        },
      },
      // Here we target the paper class
    },

    typography: {
      fontFamily: "Poppins, sans-serif", // Set Poppins as default font
      color: "rgba(0,0,0)", // Custom color for h1
      primary: {
        fontSize: 14,
        fontWeight: 300,
        color: "rgba(255,255,255)", // Custom color for h1
      },

      h1: {
        fontSize: 22,
        fontWeight: 600,
      },
      h2: {
        fontSize: 14,
        fontWeight: 300,
      },
      h3: {
        fontSize: 13,
        fontWeight: 300,
      },
    },
    palette: {
      mode: "light", // Set the mode to light
      primary: {
        main: "rgba(45,46,210,1)", //
        light: "rgba(81,83,242,1)",
        l2: "rgba(200,200,242,1)",
        l10: "rgb(217, 241, 254,1)",
      },
      secondary: {
        main: "rgba(255,255,255)", // Custom primary color for light mode
        dark: "rgba(230,230,230)", // Custom primary color for light mode
        contrastText: "rgba(0,0,0,0.5)",
      },
      chart: {
        line_blue: "rgba(100,100,255,1)", // Custom primary color for light mode
        fill_blue: "rgba(200,200,255,1)", // Custom primary color for light mode
        line_green: "rgba(0,255,100,1)", // Custom primary color for light mode
        fill_green: "rgba(200,255,200,1)", // Custom primary color for light mode
        line_light_blue: "rgba(200,200,255,1)", // Custom primary color for light mode
        fill_light_blue: "rgba(100,255,255,0.3)", // Custom primary color for light mode
        _1: "rgba(50, 130, 255, 1)",
        _2: "rgba(50, 170, 255, 1)",
        _3: "rgba(50, 210, 255, 1)",
        _4: "rgba(50, 250, 255, 1)",
        _5: "rgba(130, 50, 255, 1)",
        _6: "rgba(170, 50, 255, 1)",
        _7: "rgba(230, 50, 255, 1)",
        _8: "rgba(250, 50, 255, 1)",
        _9: "rgba(250, 200, 50, 1)",
        _10: "rgba(250, 170, 50, 1)",
        _11: "rgba(250, 130, 50, 1)",
        _12: "rgba(250, 100, 50, 1)",
      },
      background: {
        default: "rgba(255,255,255)", // Light background color
        paper: "rgba(230,230,230)", // Paper background
      },
      forever: {
        white: "rgba(255,255,255)", // Custom secondary color for light mode
        black: "rgba(0,0,0)", // Custom secondary color for light mode
      },
      shadow: {
        _50: "rgba(0,0,0,0.5)", // Custom secondary color for light mode
        _25: "rgba(0,0,0,0.25)", // Custom secondary color for light mode
        _10: "rgba(0,0,0,0.10)", // Custom secondary color for light mode
        _5: "rgba(0,0,0,0.05)", // Custom secondary color for light mode
        _2: "rgba(0,0,0,0.02)", // Custom secondary color for light mode
        _1: "rgba(0,0,0,0.01)", // Custom secondary color for light mode
      },
      accent1: {
        main: "rgba(0,230,106)", // Custom secondary color for light mode
        light: "rgba(220,255,220)",
        mobile: "rgba(155,255,159)",
      },
      accent2: {
        main: "rgba(230,50,50)", // Custom secondary color for light mode0
        light: "rgba(255,220,220)", // Custom secondary color for light mode
        l2: "rgba(255,150,200)", // Custom secondary color for light mode
      },
      accent3: {
        main: "rgba(220,144,50)", // Custom secondary color for light mode0
        light: "rgba(255,230,180)", // Custom secondary color for light mode
      },

      success: {
        main: "rgba(0,255,106)",
      },
      error: {
        main: "rgba(255,50,50)",
      },

      white: {
        main: "rgba(255,255,255)", // Custom secondary color for light mode
        dark: "rgba(230,230,230)", // Custom secondary color for light mode
        contrastText: "rgba(0,0,0)",
      },
      black: {
        main: "rgba(0,0,0)", // Custom secondary color for light mode
        light: "rgba(20,20,20)", // Custom secondary color for light mode
        contrastText: "rgba(255,255,255)", // Custom secondary color for light mode
      },
    },
  },
  frFR
);

// Define the dark theme
export const darkTheme = createTheme(
  {
    typography: {
      fontFamily: "Poppins, sans-serif", // Set Poppins as default font
      color: "rgba(255,255,255)", // Custom color for h1
      primary: {
        fontSize: 14,
        fontWeight: 300,
        color: "rgba(255,255,255)", // Custom color for h1
      },

      h1: {
        fontSize: 22,
        fontWeight: 600,
      },
      h2: {
        fontSize: 14,
        fontWeight: 300,
      },
      h3: {
        fontSize: 13,
        fontWeight: 300,
      },
    },
    palette: {
      mode: "dark", // Set the mode to dark
      primary: {
        main: "rgba(0,6,255,1)", // Custom primary color for light mode
        light: "rgba(100,100,255,1)",
        contrastText: "rgba(255,255,255)",
      },

      secondary: {
        main: "rgba(50,50,50)", // Custom primary color for light mode
        dark: "rgba(100,100,100)", // Custom primary color for light mode
      },
      background: {
        default: "rgba(0,0,0)", // Light background color
        paper: "rgba(230,230,230)", // Paper background
      },
      text: {
        primary: "rgba(255,255,255)", // Text color in light mode
        secondary: "rgba(255,255,255,0.5)", // Text color in light mode
      },
      forever: {
        white: "rgba(255,255,255)", // Custom secondary color for light mode
        black: "rgba(0,0,0)", // Custom secondary color for light mode
      },
      shadow: {
        _50: "rgba(255,255,255,0.5)", // Custom secondary color for light mode
        _25: "rgba(255,255,255,0.25)", // Custom secondary color for light mode
        _10: "rgba(255,255,255,0.10)", // Custom secondary color for light mode
        _5: "rgba(255,255,255,0.05)", // Custom secondary color for light mode
      },

      accent1: {
        main: "rgba(0,255,106)", // Custom secondary color for light mode
        light: "rgba(150,255,150)",
        mobile: "rgba(155,255,159)",
      },
      accent2: {
        main: "rgba(255,50,50)", // Custom secondary color for light mode0
        light: "rgba(255,150,150)", // Custom secondary color for light mode
      },

      white: {
        main: "rgba(0,0,0)", // Custom secondary color for light mode
        dark: "rgba(20,20,20)", // Custom secondary color for light mode
        contrastText: "rgba(255,255,255)",
      },
      black: {
        main: "rgba(255,255,255)", // Custom secondary color for light mode
        dark: "rgba(230,230,230)", // Custom secondary color for light mode
        contrastText: "rgba(0,0,0)",
      },
    },
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          listbox: {
            backgroundColor: "white",
          },
          option: {
            color: "black", // Optional: change text color
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            "& .MuiSvgIcon-root": {
              borderRadius: "02px", // Apply border radius globally to all checkboxes
            },
          },
        },
      },
    },
  },
  frFR
);

export function flutterColorToHex(colorint) {
  // Extract ARGB components
  const alpha = (colorint >> 24) & 0xff;
  const red = (colorint >> 16) & 0xff;
  const green = (colorint >> 8) & 0xff;
  const blue = colorint & 0xff;

  const res = `#${[red, green, blue].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
  if (res === "#000000") {
    return "transparent";
  }
  // Convert each component to a 2-digit hex value and combine them
  return res;
}

export function HexColorToFlutter(hex) {
  // Remove the leading '#' if it exists
  hex = hex.replace("#", "");

  // If the hex is in RGB format (6 characters), prepend 'FF' for full opacity
  if (hex.length === 6) {
    hex = "FF" + hex;
  }

  // Parse the hex string as an integer
  return parseInt(hex, 16);
}
export default lightTheme;
